"use client"

import { useMemo } from "react"

import { getSbLocaleFromHostAndUri } from "@/lib/locale-helper"

export default function VersionInfoClient(props: {
  nodeEnv: string | undefined
  deployEnv: string | undefined
  appVersion: string | undefined
}) {
  const sbLocale = useMemo(() => {
    return typeof window !== "undefined"
      ? getSbLocaleFromHostAndUri(window.location.hostname, window.location.pathname)
      : ""
  }, [])

  const versionInfo = ` NODE_ENV: ${props.nodeEnv ?? ""} DEPLOY_ENV: ${props.deployEnv ?? ""} sbLocale: ${sbLocale} NEXT_PUBLIC_APP_VERSION: ${props.appVersion ?? ""}`

  return <>{versionInfo}</>
}
